module.exports = __webpack_public_path__ + "img/1.295ef870.jpg";